/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './Renegociacao25EmpDDA.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import WhiteButton from '@/components/atoms/WhiteButton';

function Renegociacao25EmpDDA() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="renegociacao25-emp-dda">
        <ContainerHome24>
          <div className="dda-contain">
            <div className="dda-textos">
              {typeof window === 'undefined' ? (
                <></>
              ) : (
                <>
                  {width <= 992 && (
                    <h3 className="dda-titulo">Acesse a 2ª via do boleto de seu acordo</h3>
                  )}
                  {width > 992 && (
                    <h3 className="dda-titulo">Acesse a 2ª via do boleto de seu acordo</h3>
                  )}
                </>
              )}
              <p className="dda-texto">
                Consulte sua dívida e baixe o boleto de forma fácil e rápida.
              </p>
            </div>
            <WhiteButton
              href="https://quiteja.com.br/parceiros/sim"
              target="_blank"
              className="btn-dda"
            >
              Acessar boleto
            </WhiteButton>
          </div>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 992 && (
                <img src="assets/renegociacao25/ic-dda.svg" alt="" className="ic-dda" />
              )}
              {width > 992 && (
                <img src="assets/renegociacao25/ic-dda-desk.svg" alt="" className="ic-dda" />
              )}
            </>
          )}
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default Renegociacao25EmpDDA;
